import i18n from 'i18next';
import React from 'react';
import { loadDefaultJapaneseParser, loadDefaultSimplifiedChineseParser, loadDefaultTraditionalChineseParser, } from 'budoux';
import { IntlMessageFormat } from 'intl-messageformat';
const parsers = {};
function getParser(locale) {
    if (!parsers[locale]) {
        switch (locale) {
            case 'ja':
                parsers[locale] = loadDefaultJapaneseParser();
                break;
            case 'zh-Hans':
                parsers[locale] = loadDefaultSimplifiedChineseParser();
                break;
            case 'zh-Hant':
                parsers[locale] = loadDefaultTraditionalChineseParser();
                break;
            default:
                throw Error(`Cannot invoke this method for locale ${locale}`);
        }
    }
    return parsers[locale];
}
function prepareText(children, parser) {
    const fragments = [];
    if (typeof children === 'string') {
        return React.createElement(React.Fragment, null, combineStringFragments(parser.parse(children)));
    }
    for (const [i, child] of children.entries()) {
        if (typeof child !== 'string') {
            const childCopy = Object.assign(Object.assign({}, child), { props: Object.assign({ children: combineStringFragments(parser.parse(child.props.children[0])) }, child.props), key: i });
            fragments.push(childCopy);
        }
        else {
            const combinedFragment = combineStringFragments(parser.parse(child));
            fragments.push(combinedFragment);
        }
    }
    return React.createElement("span", null, fragments);
}
function combineStringFragments(fragments) {
    return fragments.map((el, i) => {
        return (React.createElement("span", { style: { whiteSpace: 'nowrap' }, key: i }, el));
    });
}
const TextWrap = ({ locale, children, }) => {
    switch (locale) {
        case 'ko':
            return React.createElement("span", { style: { wordBreak: 'keep-all' } }, children);
        case 'ja':
        case 'zh-Hans':
        case 'zh-Hant':
            return prepareText(children, getParser(locale));
        default:
            return React.createElement("span", null, children);
    }
};
const TextDir = ({ locale, children, formatValue }) => {
    const formattedMessage = new IntlMessageFormat(children, locale).format(formatValue);
    return (React.createElement("div", { dir: i18n.dir(locale) },
        React.createElement(TextWrap, { locale: locale }, formattedMessage)));
};
export default TextDir;
